import { render, staticRenderFns } from "./CustomLabel.vue?vue&type=template&id=fa58d062&"
import script from "./CustomLabel.ts?vue&type=script&lang=js&"
export * from "./CustomLabel.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports